module.exports = __webpack_public_path__ + "static/media/product.353f4349.svg";